import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import { isMobile } from "../../../../../common/parameters";

import { amazonHost } from "../../../../paths";
import Icon from "../../../../icon";
import routing from "../../../../routing";

import {
    StyledHero,
    Background,
    HeroContent,
    ToEducation,
    ForChoirs,
} from "./styles";
import messages from "./messages";
import { IProps } from "./types";
import { Link } from "react-router-dom";

const Hero = ({ forChoirs }: IProps) => {
    const [scrollTop, setScrollTop] = useState(0);
    useEffect(() => {
        if (!isMobile) {
            window.addEventListener("scroll", onScroll);
        }
        return () => {
            window.removeEventListener("scroll", onScroll);
        }
    }, []);
    const onScroll = () => {
        const doc = document.documentElement;
        setScrollTop((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0));
    };

    return (
        <StyledHero>
            <Background
                style={{
                    backgroundImage: `url(${amazonHost + routing.choir + "/landing/hero.jpg"})`,
                    transform: `translate3d(0, ${scrollTop / 3}px, 0)`,
                }}
            ></Background>
            <HeroContent>
                <h1>
                    <FormattedMessage {...(forChoirs ? messages.h1 : messages.applicantsH1)}/>
                </h1>
                <h2>
                    <FormattedMessage {...(forChoirs ? messages.h2 : messages.applicantsH2)} />
                </h2>
                {!forChoirs && (
                    <ForChoirs as={Link} to={`/${routing.choir}/${routing.choirHome}`}>
                        <FormattedMessage {...messages.forChoirs} /> <Icon i="arrowback" />
                    </ForChoirs>
                )}
                {!forChoirs && (
                    <ToEducation href="/">
                        <FormattedMessage {...messages.toClassroomEducation} /> <Icon i="arrowback" />
                    </ToEducation>
                )}
            </HeroContent>
        </StyledHero>
    );
}

export default Hero;
